module.exports = __webpack_public_path__ + "static/media/3_col_9.9deba7c1.jpg";